import * as stylex from '@stylexjs/stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex.ts';
import { colors } from '@shared/tokens/colors.stylex.ts';
import { palette } from '@shared/tokens/palette.stylex.ts';
import { typography } from '@shared/tokens/typography.stylex.ts';

export const styles = stylex.create({
  bubbleMenuSmall: {
    padding: '12px 16px',
  },
  bubbleMenu: {
    position: 'relative',
    zIndex: 10,
    display: 'flex',
    gap: '12px',
    padding: '18px',
    borderRadius: anatomy.borderRadiusS,
    background: colors.primaryBackground,
    boxShadow: '0 0 20px 0 #00000014',
    color: colors.secondaryBackground,
    ':not(#__unused__) > button': {
      padding: anatomy['size-4'],
    },
    ':not(#__unused__) > button:hover': {
      color: `${colors.accentText}`,
    },
  },
  menuActive: {
    color: `${colors.accentText} !important`,
  },
  linkContainer: {
    minHeight: '36px',
    width: '244px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  link: {
    width: '100%',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    background: 'transparent',
    border: `1px solid ${palette['darked-10']}`,
    borderRadius: anatomy.borderRadiusS,
    outline: 'none',
    padding: '8px 16px',
    height: '36px',
    '::placeholder': {
      color: palette['grey-500'],
    },
  },
  linkError: {
    borderColor: colors.errorBorder,
  },
  linkErrorText: {
    fontSize: typography['fontSizeCaption-3'],
    lineHeight: '12px',
    color: colors.errorText,
    marginBottom: '-2px',
  },
});
